import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { useDispatch } from "react-redux";
import { initDadosUsuarioForm, saveUserData } from "../../../store/actions/dadosUsuarioActions";
import { reduxForm } from "redux-form";
import Message from '../../../commons/utils/message'
import DataField from "../../../commons/components/dataField";
import CardContainer from "../../../commons/components/cardContainer"
import If from "../../../commons/utils/if";

import Utils from "../../../commons/utils/utils"

function PersonalContainer({ userData, handleSubmit }) {
    const [editing, setEditing] = useState(false);
    const [actingEdit, setActingEdit] = useState(false);
    const dispatch = useDispatch();

    function renderEditButton() {
        if (editing) {
            return (
                <>
                    <a style={{ marginRight: 24 }} onClick={() => setEditing(!editing)}
                        className={"account-link"}>Cancelar
                    </a>
                    <button type="submit" className={"account-button account-button-primary"}>Salvar alterações</button>
                </>
            )
        } else {
            return (
                <button onClick={initUserForm} className={"account-button account-button-default"}>Editar dados Pessoais</button>
            )
        }
    }

    function initUserForm() {
        setEditing(!editing);
        dispatch(initDadosUsuarioForm())
    }

    function handleDispatch(values) {
        values.first_name = values.first_name.trim();
        values.last_name = values.last_name.trim();

        if (values.developer === "sim") {
            values.developer = true
        } else {
            values.developer = false
        }

        if (values.phone && !Utils.validateDDD(values.phone)) {
            Message.showWarning(`O DDD informado não é válido!`)
        } else if (values.birth_date && values.birth_date.substr(-4) >= new Date().getUTCFullYear()) {
            Message.showWarning(`A data de nascimento não pode ser superior ao ano atual!`)
        } else if (values.first_name && !Utils.validateName(values.first_name)) {
            Message.showWarning(`Apenas letras são permitidas no campo Nome!`)
        } else if (!values.first_name) {
            Message.showWarning(`O campo nome é obrigatório!`)
        } else if (values.last_name && !Utils.validateName(values.last_name)) {
            Message.showWarning(`Apenas letras são permitidas no campo Sobrenome!`)
        } else if (!values.last_name) {
            Message.showWarning(`O campo sobrenome é obrigatório!`)
        } else {
            dispatch(saveUserData(values));
            setEditing(!editing);
            setActingEdit(!actingEdit)
        }
    }

    return (
        <form onSubmit={handleSubmit(values => handleDispatch(values))}>
            <Row style={{
                display: "flex",
                alignItems: "center",
                marginTop: 42,
            }}>
                <Col span={12}>
                    <h3 className={"dados-subheader"}>Dados Pessoais</h3>
                </Col>

                <Col span={12}>
                    <div style={{ textAlign: "end" }}>
                        {renderEditButton()}
                    </div>
                </Col>
            </Row>

            <CardContainer>
                <DataField name={"first_name"} label={"Nome:"} labelText={"Primeiro nome"}
                    secondName={"last_name"} secondLabel={"Sobrenome"} secondLabelText={"Sobrenome"}
                    editing={editing} value={userData.user_name} />

                <DataField name={"birth_date"} label={"Data de Nascimento:"} editing={editing}
                    labelText={"Data de Nascimento"}
                    value={Utils.formatDate(userData.birth_date)} mask="date" />

                <DataField name={"phone"} label={"Telefone:"} labelText={"Número com DDD"}
                    editing={editing}
                    value={Utils.formatNumber(userData.phone)}
                    mask="phone" />

                <Row gutter={20} style={{
                    paddingBottom: 16,
                    marginTop: 16
                }}>
                    <Col span={4}>
                        <span className={"account-card-label"}>CPF:</span>
                    </Col>
                    <Col span={6}>
                        <span className={"account-card-data"}>{Utils.maskCpf(userData.identification_number)}</span>
                        <If test={editing}>
                            <p className={"account-card-info"}>Não é possível alterar o seu CPF, caso precise de ajuda,
                                contate nosso suporte.</p>
                        </If>
                    </Col>
                    <Col span={14}>

                    </Col>
                </Row>

                {userData.developer &&
                    <Row
                        gutter={20}
                        style={{
                            paddingBottom: 16,
                            paddingTop: 16,
                            borderTop: "1px solid #eceef1"
                        }}
                    >
                        <Col span={4}>
                            <span className={"account-card-label"}>Desenvolvedor Sankhya:</span>
                        </Col>
                        <Col span={6}>
                            <span className={"account-card-data"}>{userData.developer ? 'Sim' : 'Não'}</span>

                            <p className={"account-card-info"}> Um desenvolvedor é quem personaliza as soluções Sankhya
                                construindo Dashboards, Campos e Telas Adicionais, Extensões
                                e outras soluções personalizadas para clientes.
                            </p>
                        </Col>
                        <Col span={7}>

                        </Col>
                    </Row>
                }
            </CardContainer>

        </form>
    )
}

export default reduxForm({ form: 'editUserData' })(PersonalContainer);
